import { createRoot } from 'react-dom/client';
import App from './App';
import { mergeStyles } from '@fluentui/react';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/scrollToTop';
import { GlobalContextProvider } from './_contexts/GlobalContext';

// Inject some global styles
mergeStyles({
  ':global(body,html,#root)': {
    margin: 0,
    padding: 0,
    height: '100vh',
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <GlobalContextProvider>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </GlobalContextProvider> 
);
